import { useSelector } from 'react-redux';

import { getIsReOpsUser } from 'entities/User';
import { getUserCanSeeSavingsInsights } from 'entities/User/model/selectors/userPermissionsSeletors';
import { useFeatureFlag } from 'shared/lib/hooks/useFeatureFlag';

/**
 * Savings Summary report is visible only when:
 * - User has API_SEE_SAVINGS_INSIGHTS permission, AND
 * - Flipt flag `report_savings_enabled` is true, OR
 * - User has a RE-OPS email (@re-ops.co), matching in-order-savings behavior.
 *
 * Returns:
 * - `true` when the report should be visible
 * - `false` when it should not be visible
 * - `undefined` while underlying permissions/flags are still resolving
 */
export const useSavingsSummaryReportVisible = (): boolean | undefined => {
    const reportSavingsEnabled = useFeatureFlag('report_savings_enabled');
    const canSeeSavingsInsights = useSelector(getUserCanSeeSavingsInsights);
    const isReOpsUser = useSelector(getIsReOpsUser);

    if (reportSavingsEnabled === null) {
        return undefined;
    }

    if (!canSeeSavingsInsights) {
        return false;
    }

    return reportSavingsEnabled === true || isReOpsUser;
};
